<template>
    <div>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Análisis de caracter</h4>
        </div>
        <card  class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title-orange">Análisis de caracter</h6>
            </div>
            <div class="card-body">
                <div id="chart">
                    <apexchart ref="chart" type="radar" height="350" :options="chartOptions" :series="series"></apexchart>
                </div>
            </div>
            <div class="card-footer">
                <p class="chart-footer">E: Estabilidad<br>H: Habilidad empresarial<br>RP: Responsabilidad de pagos<br>R: Reputación</p>
            </div>
        </card>
        <div class="text-right">
            <p-button @click="toFinancialIndicators()" type="warning">Siguiente</p-button>
            <p-button @click="toCharacterAnalysis()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import fab from 'vue-fab'
    import VueScrollTo from 'vue-scrollto'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import CharacterAnalysis from 'src/util/CharacterAnalysis/CharacterAnalysis'
    import PProgress from 'src/components/UIComponents/Progress.vue'
    import VueApexCharts from 'vue-apexcharts'
    import moment from 'moment'
    Vue.component('apexchart', VueApexCharts)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            fab,
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            PProgress,
        },
        data() {
        return {
            consumer: false,
            microcredit: false,
            pyme: false,
            agro: false,
            categories: [],
            modelValidations: {
                statement : {
                    required: true
                }
            },
            series: [{
                name: 'Riesgo',
                data: [100, 100, 100, 100],
            }, {
                name: 'Cobertura',
                data: [0, 0, 0, 0],
            }],
            chartOptions: {
                chart: {
                    toolbar: {
                        show: false
                    },
                    foreColor: '#FFFFFF',
                    height: 550,
                    type: 'radar',
                    dropShadow: {
                        enabled: true,
                        blur: 1,
                        left: 1,
                        top: 1
                    }
                },
                legend: {
                    onItemClick: {
                        toggleDataSeries: false
                    },
                    onItemHover: {
                        highlightDataSeries: false
                    },
                },
                colors: ['#9999ff', '#993366'],
                
                fill: {
                    opacity: 0.5
                },
                markers: {
                    size: 0
                },
                xaxis: {
                    categories: ['E','H','RP','R'],
                },
                yaxis: {
                    min:0,
                    max: 100,
                    show: false
                },
            },
        }
        },
        watch: {

        },
        computed: {
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (product.name.toLowerCase() == 'consumo') {
                    this.consumer = true;
                    this.microcredit = false;
                    this.pyme = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                    this.microcredit = true;
                    this.consumer = false;
                    this.pyme = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.microcredit = false;
                    this.consumer = false;
                    this.pyme = true;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'agropecuario') {
                    this.microcredit = false;
                    this.consumer = false;
                    this.pyme = false;
                    this.agro = true;
                }
                else {
                    // this.showNotificationError('Este tipo de producto aún no es implementado en EMI');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toBalance () {
                this.$router.push('/asessments/new_asessment/customer/others/additional_information');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toCharacterAnalysis () {
                this.$router.push('/asessments/new_asessment/customer/others/character_analysis');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toFinancialIndicators () {
                var payload = {
                    stage: 'Análisis de caracter',
                    description: 'Se visualiza el gráfico de análisis de caracter.',
                    dateTime: moment().format()
                };
                if (this.consumer) {
                    this.$store.dispatch('setChangeLog', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/financial_indicators_consumer');
                    });
                }
                else if(this.microcredit) {
                    this.$store.dispatch('setChangeLog', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/financial_indicators');
                    });
                }
                else if(this.pyme) {
                    this.$store.dispatch('setChangeLog', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/financial_indicators');
                    });
                }
                else if(this.agro) {
                    this.$store.dispatch('setChangeLog', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/agro/cash_flow');
                    });
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveReferences () {
                if (this.products.length != 0) {
                    this.$store.dispatch('setReferences', this.products).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                    });
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
            }
        },
        mounted () {
            // if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].characterAnalysis.length != 0) {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].characterAnalysis.length != 0) {
                    this.categories = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].characterAnalysis;
                    for (let i=0;i<this.categories.length;i++) {
                        this.series[1].data[i] = this.categories[i].yes_value;
                    }
                    this.$refs.chart.refresh();
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                    this.productValidator(product);
                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].characterAnalysis.length != 0) {
                    this.categories = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].characterAnalysis;
                    for (let i=0;i<this.categories.length;i++) {
                        this.series[1].data[i] = this.categories[i].yes_value;
                    }
                    this.$refs.chart.refresh();
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                    this.productValidator(product);
                }
            }
            if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].characterAnalysis.length != 0) {
                    this.categories = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].characterAnalysis;
                    for (let i=0;i<this.categories.length;i++) {
                        this.series[1].data[i] = this.categories[i].yes_value;
                    }
                    this.$refs.chart.refresh();
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                    this.productValidator(product);
                }
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .chart-footer{
        color: white !important;
        font-size: 10px !important;
    } 
</style>
